import { Layout } from "antd";
import React, { ReactElement } from "react";
const { Footer } = Layout;

const MainFooter = (): ReactElement => {
  return <Footer className="text-center">Powered by Jachai.com Ltd.</Footer>;
};

export default MainFooter;
